import React from 'react';
import { Chip, IconButton, Stack } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { useSelector } from 'react-redux';
import { useNavigation } from 'react-router-dom';
import { NameChangeField } from '@/components/cards/DealCardValues/NameChangeField';
import { useObjectContext } from '@/hooks/useObjectContext';
import { DEAL_STATUS_TYPES } from '@/utils/constants';
import { useTabContext } from './TabContext';

export const TabHeaderName = () => {
	const navigation = useNavigation();

	const { dealRow, loading, isClientView: isClient } = useObjectContext();
	const isClientFolderDriveIdLoading = useSelector(
		(state) => state.attachmentsTable.folderContextLoading,
	);

	const isLoading = navigation.state == 'loading' || loading || isClientFolderDriveIdLoading;

	const { isEditing, startEditing } = useTabContext();

	return (
		<Stack direction='row' alignItems='center' justifyContent={'space-between'}>
			<Stack direction={'row'} alignItems={'center'} spacing={1} width='100%'>
				<NameChangeField />
				{!isClient && dealRow?.status === DEAL_STATUS_TYPES.archived && !isEditing && (
					<Chip size='small' label='ARCHIVED' variant='outlined' color='error' />
				)}
			</Stack>
			{!isEditing && (
				<IconButton
					sx={{ marginLeft: 5 }}
					color='primary'
					aria-label='edit'
					disabled={isLoading}
					edge='start'
					onClick={startEditing}
				>
					<EditIcon />
				</IconButton>
			)}
		</Stack>
	);
};
